import { useMutation } from 'react-query';

import { deleteComponent as mutationFn } from 'api/endPoints/deleteComponent';

export const useMutationDeleteComponent = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    componentId: string;
}
